import styled from 'styled-components';
import { media } from 'utils/styledHelpers';

interface StyledPaginationWrapperProps {
    $isMarginTop?: boolean;
    $fullscreen?: boolean;
}

const StyledPaginationWrapper = styled.div<StyledPaginationWrapperProps>`
  .ant-pagination {
    margin-top: ${(props) => (props.$isMarginTop ? '5rem' : '0')};
    width: 100%;
    display: flex;
    .ant-pagination-total-text {
      flex-grow: 1;
      line-height: 2.28rem;
      color: ${(props) => props.theme.colors.primaryText};
    }
    .ant-pagination-prev {
      margin-right: 0.7rem !important;
    }
  }
  .ant-select-single:not(.ant-select-customize-input) {
    border: 1px solid ${(props) => props.theme.colors.secondaryBorder};
  }

  .ant-table-pagination.ant-pagination {
    position: sticky;
    bottom: 0;
    height: 42px;
    padding: 2px 0.85rem;
    margin-top: 0;
    background-color: ${(props) => props.theme.colors.primaryBg};
    border: 1px solid ${(props) => props.theme.colors.secondaryBorder};
    border-top: none;
    box-shadow: 0 -4px 10px 0 #00000015;
    z-index: 50;
    border-radius: ${(props) => `0 0 ${props.theme.customBorderRadius.borderRadiusSmall} ${props.theme.customBorderRadius.borderRadiusSmall}`};

    ${(props) => props.$fullscreen
      && `
      position: fixed;
      left: 0;
      bottom: 0;
      height: auto;
      padding: 0.7rem 1.14rem !important;
      margin: 0 !important;
      border: none;
      z-index: 90;
    `};

    ${media.xs`
      height: 70px;
      flex-wrap: wrap;
      justify-content: center;
      padding-bottom: 0;
    `};

    li.ant-pagination-total-text {
      ${media.xs`
        margin-top: 0;
      `};
    }
  }

  .ant-table-pagination.ant-pagination,
  .ant-list-pagination .ant-pagination {
    display: flex;
    align-items: center;

    ${media.xs`
      flex-wrap: wrap;
      justify-content: center;
    `}
    .ant-pagination-total-text {
      margin-right: auto;
      font-size: 1rem;
      line-height: 1.8;
      color: ${(props) => props.theme.colors.primaryText};

      ${media.xs`
        order: 100;
        flex: 0 0 100%;
        text-align: center;
        line-height: auto;
        height: auto;
        margin-top: 0.71rem;
      `}
    }
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled .ant-pagination-item-link,
  .ant-pagination-disabled:hover .ant-pagination-item-link,
  .ant-pagination-disabled:focus .ant-pagination-item-link {
    border: none;
  }
  .ant-pagination-item {
    border: none;
    white-space: nowrap;
    a {
      padding: 0;
    }
  }
  .ant-pagination.ant-pagination-mini {
    .ant-pagination-item {
      margin: 0 2px !important;
      & a,
      &-active a {
        font-size: ${(props) => props.theme.typography.fontSizeSmall};
      }
    }
    .ant-pagination-prev > button.ant-pagination-item-link,
    .ant-pagination-next > button.ant-pagination-item-link {
      margin: 0 !important;
    }
  }
  .ant-list-pagination {
    margin-top: 16px;
  }
  .ant-list-pagination,
  .ant-pagination {
    text-align: left !important;
    .ant-pagination-item,
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      min-width: 2.28rem !important;
      height: 2.28rem !important;
      padding: 0 0.57rem;
      line-height: 2.28rem !important;
      background-color: transparent;
      border: none;
      margin: 0 4px !important;
      a {
        font-size: ${(props) => props.theme.typography.fontSizeDefault};
        color: ${(props) => props.theme.colors.primaryText};
        &:hover {
          color: ${(props) => props.theme.colors.blue};
        }
      }
    }

    .ant-pagination-item-link .anticon {
      color: ${(props) => props.theme.colors.secondaryColor};
      &:hover {
        color: ${(props) => props.theme.colors.blue};
      }
    }
    .ant-select-arrow .anticon {
      color: ${(props) => props.theme.colors.secondaryColor};
    }
    .ant-pagination {
      &-jump-prev,
      &-jump-next,
      &-prev {
        margin: 0;
      }
      &-prev,
      &-next,
      &-jump-prev,
      &-jump-next,
      &.mini .ant-pagination-prev,
      &.mini .ant-pagination-next {
        width: 2.28rem;
        min-width: 2.28rem !important;
        height: 2.28rem !important;
        line-height: 2.28rem !important;
        > button.ant-pagination-item-link {
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &-options {
        height: 2.28rem;
        .ant-select {
          width: 8rem;
        }
        .ant-select-content {
          height: 2.28rem;
          display: flex;
          align-items: center;
          font-size: 1rem;
          color: ${(props) => props.theme.colors.primaryText};
        }
      }
    }
    .ant-pagination-item-ellipsis {
      color: ${(props) => props.theme.colors.secondaryColor};
    }
    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.colors.hoverBg};
      color: ${(props) => props.theme.colors.blue};
      border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      a {
        color: ${(props) => props.theme.colors.blue};
      }
      &:hover,
      &:focus {
        a {
          color: ${(props) => props.theme.colors.blue};
        }
      }
    }
  }
`;
const StyledStickyPagination = styled(StyledPaginationWrapper)`
  width: 100%;
  .ant-pagination {
    padding-bottom: 0;
  }
`;

export { StyledPaginationWrapper, StyledStickyPagination };
